import { NSCommonConstants } from '@ruby/configs/common.constants';
import { EGridType } from '@ruby/shared/enums/grid.enums';
import { IGridConfigurations } from '@ruby/shared/models/commons/grid.interface';
import { NSDateUtils } from '@ruby/shared/services/utils/ns-date.utils';

export class NSCarTrafficConstants {

  static readonly carLoadGridConfigs: IGridConfigurations = {
    gridTitle: 'Traffic history 3 year summary',
    gridName: EGridType.CAR_TRAFFIC_THREE_YEAR_HISTORY,
    rowSelection: 'single',
    headerOptions: {
      hide: {
        title: false,
        customizedReporting: false,
        download: {
          xlsAll: true
        }
      }
    },
    columns: [
      {
        headerName: 'Shipper',
        field: 'shipper',
        resizable: true,
        headerClass: 'center-align',
        cellClass: 'justify-content-center'
      },
      {
        headerName: 'Origin',
        field: 'origin',
        resizable: true,
        headerClass: 'center-align',
        cellClass: 'justify-content-center'
      },
      {
        headerName: 'Receiver',
        field: 'receiver',
        resizable: true,
        headerClass: 'center-align',
        cellClass: 'justify-content-center'
      },
      {
        headerName: 'Destination',
        field: 'destination',
        resizable: true,
        headerClass: 'center-align',
        cellClass: 'justify-content-center'
      },
      {
        headerName: 'Origin Road',
        field: 'originRoad',
        resizable: true,
        headerClass: 'center-align',
        cellClass: 'justify-content-center'
      },
      {
        headerName: 'Destination Road',
        field: 'destinationRoad',
        resizable: true,
        headerClass: 'center-align',
        cellClass: 'justify-content-center'
      },
      {
        headerName: 'L/E',
        field: 'loadEmptyIndicator',
        resizable: true,
        headerClass: 'center-align',
        cellClass: 'justify-content-center'
      },
      {
        headerName: 'STCC/DESCRIPTION',
        field: 'stcc',
        resizable: true,
        headerClass: 'center-align',
        cellClass: 'justify-content-center'
      },
      {
        headerName: NSDateUtils.nsGetYear(new Date(), 2),
        field: 'twoYearsBefore',
        resizable: true,
        headerClass: 'center-align',
        cellClass: 'justify-content-center'
      },
      {
        headerName: NSDateUtils.nsGetYear(new Date(), 1),
        field: 'oneYearBefore',
        resizable: true,
        headerClass: 'center-align',
        cellClass: 'justify-content-center'
      },
      {
        headerName: 'YTD',
        field: 'ytd',
        resizable: true,
        headerClass: 'center-align',
        cellClass: 'justify-content-center'
      }
    ],
    options: {
      overlayNoRowsTemplate: NSCommonConstants.notFoundMessage
    }
  };
}
